// src/components/Logo.js
import styled from '@emotion/styled';
import { theme } from '../theme';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
`;

const LogoSymbol = styled.svg`
  width: 32px;
  height: 32px;
`;

const LogoText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: ${props => props.theme.colors.primary};
  
  .link {
    font-size: 20px;
    color: ${props => props.theme.colors.secondary};
  }
`;

function Logo() {
  return (
    <LogoContainer>
      <LogoSymbol viewBox="0 0 32 32">
        {/* Flower-like petals */}
        <path
          d="M16 2 Q18.5 6, 16 6 Q13.5 6, 16 2"
          fill={theme.colors.secondary}
        />
        <path
          d="M30 16 Q26 18.5, 26 16 Q26 13.5, 30 16"
          fill={theme.colors.secondary}
        />
        <path
          d="M16 30 Q13.5 26, 16 26 Q18.5 26, 16 30"
          fill={theme.colors.secondary}
        />
        <path
          d="M2 16 Q6 13.5, 6 16 Q6 18.5, 2 16"
          fill={theme.colors.secondary}
        />
        
        {/* Inner Circle */}
        <circle 
          cx="16" 
          cy="16" 
          r="8" 
          fill="none" 
          stroke={theme.colors.primary} 
          strokeWidth="2" 
        />
        
        {/* Main Path */}
        <path
          d="M16 6 
             Q22 16, 16 26 
             Q10 16, 16 6"
          fill="none"
          stroke={theme.colors.primary}
          strokeWidth="3"
          strokeLinecap="round"
        />
      </LogoSymbol>

      <LogoText>
        Zoe<span className="link">Technologies</span>
      </LogoText>
    </LogoContainer>
  );
}

export default Logo;